import { AccessMgmtEnvironment } from '@stantec/access-mgmt'

export const environment: any = {
  production: false,
  digitalAccessPortal: {
    environment: AccessMgmtEnvironment.DEVELOPMENT,
    applicationId: '79a65cb7-406c-4598-bfe8-e4454b0f2ec9',
    url: 'https://digital-dev.insight.stantec.com',
  },
  useConfigFile: false,
  pricingToolLink: "https://dev-debris-pricing-tool.azurewebsites.net",
  jiraLink: "https://stantecdigitalservices.atlassian.net/servicedesk/customer/portal/29/topic/f42c35b6-0cf3-4cb6-a88e-b3715f539e89"
}
